/**
 * Reduer for email templates
 */

import get from 'lodash/get';

import {
  FETCH_DEPOSIT_TRANSACTIONS,
  UPDATE_DEPOSIT_TRANSACTION,
  ADD_DEPOSIT_TRANSACTION,
  RESET_DEPOSIT_TRASACTION_REDUCER
} from '../actions/actionTypes';
import { updateItemInItems } from '../../utils';

const initialState = {
  transactions: [],
  isLoading: false,
  hasUpdate: false,
  page: 1,
  limit: 10
};

export const transactionsSelector = (state) =>
  get(state, 'depositTransactions', []);
const transactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DEPOSIT_TRANSACTIONS:
      return { ...state, ...action.data };
    case UPDATE_DEPOSIT_TRANSACTION:
      return updatedTransactions(state, action);
    case ADD_DEPOSIT_TRANSACTION:
      return addTransaction(state, action);
    case RESET_DEPOSIT_TRASACTION_REDUCER:
      return initialState;
    default:
      return state;
  }
};

const addTransaction = (state, action) => {
  const { transaction, isLoading, hasUpdate } = action.data;
  if (transaction) {
    return {
      ...state,
      isLoading,
      hasUpdate,
      transactions: [transaction, ...state.transactions]
    };
  }
  return { ...state, ...action.data };
};
const updatedTransactions = (state, action) => {
  const { transaction, ...rest } = action.data;
  if (transaction) {
    const { index, status, ...restTransactionData } = transaction;
    const content =
      state.transactions[index] && state.transactions[index].content;

    return {
      ...state,
      transactions: updateItemInItems(state.transactions, index, {
        status,
        content: { ...content, ...restTransactionData }
      }),
      ...rest
    };
  }
  return { ...state, ...action.data };
};

export default transactionReducer;
